<div class="wrapper flex flex-col h-full">
  <!-- <div class="header">
    <div class="back" (click)="jumpBackToGuestList()" *ngIf="from === 'order'">
      <i nz-icon nzType="left" nzTheme="outline"></i>
    </div>
    <div class="name">{{ guestDetail?.name }}</div>
    <div></div>
  </div> -->
  <div class="flex-1 overflow-y-auto pb-[70px]">
    <div class="v4-layout-info">
      <div class="v4-layout-info-title">
        <!-- 个人信息 -->
        {{ "order.guest_detail.personal_information" | translate }}
      </div>

      <div class="v4-layout-field" *ngIf="guestDetail?.name">
        <div class="v4-layout-field-label">
          <!-- 姓名： -->
          {{ "order.guest_detail.name" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <span>{{ guestDetail?.name }}</span>
            <img
              *ngIf="guestDetail?.gender"
              class="ml-1 w-[14px] h-[14px]"
              [src]="guestDetail?.gender === 1 ? '/assets/guest/male.png' : '/assets/guest/female.png'" />
          </div>
        </div>
      </div>

      <div class="v4-layout-field" *ngIf="guestDetail?.has_mobile">
        <div class="v4-layout-field-label">
          <!-- mobile： -->
          {{ "modal.add_guest.form.mobile" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <span class="mr-2">{{ guestDetail?.phone }}</span>
            <button class="no-min-width" hostClipboard [clipboardData]="guestDetail?.phone" nz-button nzSize="small">
              Copy
            </button>
          </div>
        </div>
      </div>

      <div class="v4-layout-field" *ngIf="guestDetail?.email">
        <div class="v4-layout-field-label">
          <!-- email： -->
          {{ "modal.add_guest.form.email" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <span>{{ guestDetail?.email }}</span>
          </div>
        </div>
      </div>

      <div class="v4-layout-field" *ngIf="guestDetail?.id_type">
        <div class="v4-layout-field-label">
          <!-- document： -->
          {{ "modal.add_guest.form.id_type" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <span>{{ guestDetail?.id_type | credential }} {{ guestDetail?.id_number }}</span>

            <div
              *ngIf="guestDetail?.client_credential?.length"
              class="ml-2 text-primary cursor-pointer"
              (click)="showCredentials(guestDetail?.client_credential)">
              <img class="w-[13px] h-[13px]" src="/assets/icon/attachment.png" alt="" />
              <span>{{ guestDetail?.client_credential?.length }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="v4-layout-field" *ngIf="guestDetail?.birthday">
        <div class="v4-layout-field-label">
          <!-- date of birth： -->
          {{ "modal.add_guest.form.birthday" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <span>{{ guestDetail?.birthday | dateformat: ["YMD"] }}</span>
          </div>
        </div>
      </div>

      <div class="v4-layout-field" *ngIf="guestDetail?.country">
        <div class="v4-layout-field-label">
          <!-- nationality： -->
          {{ "modal.add_guest.form.country" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <span>{{ getCountryName(guestDetail?.country) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="v4-layout-info">
      <div class="v4-layout-info-title">
        <!-- 消费历史 -->
        {{ "order.guest_detail.consumption_history" | translate }}
      </div>
      <div class="v4-layout-field" *ngIf="guestDetail?.consumer_info?.cumulative_consumer">
        <div class="v4-layout-field-label">
          <!-- 累计消费： -->
          {{ "order.cumulative_consumption" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <span>{{ guestDetail?.consumer_info?.currency_type }}</span>
            <span class="ml-1">{{ guestDetail?.consumer_info?.cumulative_consumer }}</span>
          </div>
        </div>
      </div>
      <div class="v4-layout-field" *ngIf="guestDetail?.consumer_info?.checkin_times">
        <div class="v4-layout-field-label">
          <!-- 入住次数： -->
          {{ "order.guest_detail.checkin_times" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            {{ guestDetail?.consumer_info?.checkin_times }}

            <a
              routerLink="/app/reservations"
              [queryParams]="{ client_id: guestDetail?.id, client_name: guestDetail?.name }"
              target="_blank">
              <button class="ml-[8px] no-min-width" nz-button nzSize="small">{{ "word.detail" | translate }}</button>
            </a>
          </div>
        </div>
      </div>
      <div class="v4-layout-field" *ngIf="guestDetail?.consumer_info?.avg_reservation_price">
        <div class="v4-layout-field-label">
          <!-- 订单均价： -->
          {{ "order.guest_detail.avg_reservation_price" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <span>{{ guestDetail?.consumer_info?.currency_type }}</span>
            <span style="padding-left: 5px">{{ guestDetail?.consumer_info?.avg_reservation_price }}</span>
          </div>
        </div>
      </div>
      <div class="v4-layout-field" *ngIf="guestDetail?.consumer_info?.total_nights !== 0">
        <div class="v4-layout-field-label">
          <!-- 间夜数： -->
          {{ "order.guest_detail.total_nights" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            {{ guestDetail?.consumer_info?.total_nights }}
          </div>
        </div>
      </div>
      <div class="v4-layout-field" *ngIf="guestDetail?.consumer_info?.avg_night_price">
        <div class="v4-layout-field-label">
          <!-- 间夜均价： -->
          {{ "order.guest_detail.avg_night_price" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <span>{{ guestDetail?.consumer_info?.currency_type }}</span>
            <span class="ml-1">{{ guestDetail?.consumer_info?.avg_night_price }}</span>
          </div>
        </div>
      </div>
      <div class="v4-layout-field" *ngIf="guestDetail?.consumer_info?.last_checkin_time">
        <div class="v4-layout-field-label">
          <!-- 上次入住： -->
          {{ "order.last_checkin" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            {{ guestDetail?.consumer_info?.last_checkin_time | dateformat: ["YMD"] }}
          </div>
        </div>
      </div>
      <div class="v4-layout-field" *ngIf="guestDetail?.consumer_info?.first_checkin_time">
        <div class="v4-layout-field-label">
          <!-- 首次入住： -->
          {{ "order.guest_detail.first_checkin" | translate }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            {{ guestDetail?.consumer_info?.first_checkin_time | dateformat: ["YMD"] }}
          </div>
        </div>
      </div>

      <!-- channel -->
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          {{ "guest-detail_html_label_channel" | translate }}
          <!-- Channel: -->
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-avatar-group>
              @for (t of guestDetail?.thirdpartys; track $index) {
                <nz-avatar [nzSize]="24" [nzSrc]="(t | thirdparty)?.icon_color_bg"></nz-avatar>
              }
            </nz-avatar-group>
          </div>
        </div>
      </div>

      <!-- property -->
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          {{ "guest-detail_html_label_property" | translate }}
          <!-- Property: -->
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            {{ guestDetail?.property?.join("、") || "-" }}
          </div>
        </div>
      </div>
    </div>
    <div class="v4-layout-info" *ngIf="guestDetail?.client_comment?.comment">
      <div class="v4-layout-info-title">{{ "word.remarks" | translate }}</div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            {{ guestDetail?.client_comment?.comment }}
          </div>
        </div>
      </div>
    </div>
    <div class="v4-layout-info" *ngIf="guestDetail?.client_tags.length > 0">
      <div class="v4-layout-info-title">
        <!-- 标签 -->
        {{ "word.tag" | translate }}
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <div class="v4-tag-list">
            <div class="v4-tag mr-2" *ngFor="let label of guestDetail?.client_tags" [style.background]="label?.color">
              {{ label.name }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="v4-layout-info" *ngIf="guestDetail?.client_credential.length > 0">
      <div class="v4-layout-info-title">{{ "word.credentials" | translate }}</div>

      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <div class="mr-[10px] cursor-pointer" *ngFor="let img of guestDetail?.client_credential; index as i">
              <img class="h-16 w-16" [hostImgPreview]="img?.urls?.large_url" [src]="img?.urls?.small_url" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <a nz-button nzType="link" *ngIf="guestDetail?.has_similar" (click)="checkSimilarGuest()">
      <!-- 部分信息与其他房客重复 -->
      {{ "order.similar_to_other_guest" | translate }} >
    </a>

    <!-- <div class="delete" (click)="deleteGuest()">
      删除
      {{ "word.delete" | translate }}
    </div> -->
  </div>
  <div class="pt-[30px] border-t border-solid border-c-gs">
    <button class="mr-3" nz-button nzSize="large" (click)="closePannel()">
      {{ "word.close" | translate }}
    </button>
    <button nz-button nzSize="large" (click)="modify()">
      {{ "word.modify" | translate }}
    </button>
  </div>
</div>
